import type { LogoutPlanInput } from 'src/auth/logout-plan-input';
import type { LogoutPlan } from 'src/auth/logout-plan';
import type { LogoutReturnState } from 'src/auth/logout-return-state';

export function createCriiptoLogoutUrl(basePath: string, origin: string): string {
  return `${basePath}/auth/criipto/logout?redirect_uri=${encodeURIComponent(origin)}`;
}

export function planLogout(input: LogoutPlanInput): LogoutPlan {
  const useCriiptoIdpLogout = input.criiptoIdpLogoutActive && input.provider === 'criipto';

  if (useCriiptoIdpLogout) {
    return {
      logoutPath: 'criipto-idp',
      destination: createCriiptoLogoutUrl(input.basePath, input.origin),
      postLogoutRedirectToSignin: input.redirectToSignin,
      postLogoutProvider: 'criipto',
    };
  }

  return {
    logoutPath: 'local',
    destination: input.redirectToSignin ? '/signin?showExpired=true' : '/',
    postLogoutRedirectToSignin: input.redirectToSignin,
  };
}

export function getLogoutReturnRedirect(state: LogoutReturnState): string | undefined {
  if (shouldObserveLogoutReturn(state) && state.postLogoutRedirectToSignin) {
    return '/signin?showExpired=true';
  }

  return undefined;
}

export function shouldSkipLogoutReturnHandling(state: LogoutReturnState): boolean {
  if (state.pathname !== '/' || state.search === undefined || state.search === '') {
    return false;
  }

  const searchParams = new URLSearchParams(state.search.slice(1));
  return searchParams.has('code') || searchParams.has('error');
}

export function shouldForcePromptLoginAfterLogoutError(state: LogoutReturnState): boolean {
  if (state.pathname !== '/' || state.search === undefined || state.search === '') {
    return false;
  }

  const searchParams = new URLSearchParams(state.search.slice(1));
  return (
    state.pendingCriiptoLogoutReturn === true && state.postLogoutProvider === 'criipto' && searchParams.has('error')
  );
}

export function shouldObserveLogoutReturn(state: LogoutReturnState): boolean {
  return state.pathname === '/' && state.pendingCriiptoLogoutReturn === true && state.postLogoutProvider === 'criipto';
}

export function getPostLogoutStorageState(plan: LogoutPlan): {
  postLogoutRedirectToSignin?: 'true';
  postLogoutProvider?: 'criipto';
} {
  if (plan.postLogoutProvider === undefined) {
    return {};
  }

  return {
    postLogoutProvider: plan.postLogoutProvider,
    postLogoutRedirectToSignin: plan.postLogoutRedirectToSignin ? 'true' : undefined,
  };
}
